import {getAllCurrentTaxRates} from "../../utils/other";
import {DIRECTION_NAME} from "../../constants";
import moment from "moment";

const PROD_VAT = "A";
const TEST_VAT = "A";

const toNumber = (value) => isNaN(Number(value)) ? 0 : Number(value);

const createSummarized = () => ({
    baseAmount: 0,
    pdv: 0,
    unitPrice: 0,
    discount: 0,
    totalAmount: 0
});

export const invoiceItemsForShow = (data) => {
    const {
        price = 0,
        returnPrice = 0,
        priceMonthly = 0,
        passengers = [],
        directionType = null,
        externalSale = false
    } = data;

    const prices = {price, returnPrice, priceMonthly};
    let foundPriceByDirection = getDirectionPrice(directionType, prices, externalSale);

    const itemsArr = passengers.map((passenger) => {
        const discountPCT = passenger?.discountPCT || {};
        let basePrice = toNumber(foundPriceByDirection);

        if (discountPCT?.applyDiscountOneWay && directionType === DIRECTION_NAME[0]) {
            basePrice = discountPCT.priceOneWay;
        }
        if (discountPCT?.applyDiscountReturnTicket && directionType === DIRECTION_NAME[1]) {
            basePrice = discountPCT.priceReturnTicket;
        }
        const shouldRoundPrice = (discountPCT.applyDiscountOneWay && directionType === DIRECTION_NAME[0]) ||
            (discountPCT.applyDiscountReturnTicket && directionType === DIRECTION_NAME[1]);

        const finalPrice = shouldRoundPrice && discountPCT?.applyRoundPrice && !discountPCT?.explicit
            ? Math.ceil(basePrice / 10) * 10
            : basePrice;

        return {
            price: finalPrice,
            name: discountPCT?.name || "Osnovna",
            quantity: 1
        };
    });

    return itemsArr.reduce((acc, current) => {
        const existingItem = acc.find(item => item.price === current.price && item.name === current.name);
        if (existingItem) {
            existingItem.quantity += 1;
        } else {
            acc.push(current);
        }
        return acc;
    }, []);
};


export const invoiceTotalAmount = (data) => {
    const {
        price = 0,
        returnPrice = 0,
        priceMonthly = 0,
        passengers = [],
        saleAction = null,
        services = [],
        directionType = null,
        currentTaxRates = [],
        isTicketPriceConfirmation = false,
        externalSale = false,
        isInternational = false
    } = data;

    let totalSummary = createSummarized();
    const prices = {price, returnPrice, priceMonthly}
    let foundPriceByDirection = getDirectionPrice(directionType, prices, externalSale)

    let regularPrice = getDirectionPrice(directionType, prices, externalSale)
    passengers.forEach((passenger) => {
        if (passenger.discountPCT && isTicketPriceConfirmation !== true) {
            const {priceOneWay: price, priceReturnTicket: returnPrice, priceMonthly} = passenger.discountPCT;
            foundPriceByDirection = getDirectionPrice(directionType, {price, returnPrice, priceMonthly}, externalSale);
        }
        const passengerSummary = amountByPassenger(passenger, currentTaxRates, foundPriceByDirection, isTicketPriceConfirmation, regularPrice, directionType);
        totalSummary = aggregateSummaries(totalSummary, passengerSummary);
    });
    // services.forEach((service) => {
    //     const serviceSummary = amountByService(service, currentTaxRates, saleAction?.discountPCT || 0, saleAction?.discountABS || 0, passengers.length);
    //     totalSummary = aggregateSummaries(totalSummary, serviceSummary);
    // });

    const serviceSummary = amountByService(services, currentTaxRates, saleAction?.discountPCT || 0, saleAction?.discountABS || 0, passengers.length);

    totalSummary = aggregateSummaries(totalSummary, serviceSummary);
    totalSummary = amountBySalesAction(totalSummary, saleAction, currentTaxRates, passengers?.length, isInternational, 1);

    return totalSummary;
};

// OUTPUT  baseAmount, pdv, price, discount
const amountByPassenger = (passenger, currentTaxRates, price, isTicketPriceConfirmation, regularPrice, directionType) => {
    const finalCalculation = createSummarized();
    if (isTicketPriceConfirmation) {
        finalCalculation.unitPrice = toNumber(price);
        finalCalculation.totalAmount = toNumber(price);
        finalCalculation.discount = 0;
        finalCalculation.baseAmount = calculateBase(finalCalculation.unitPrice, currentTaxRates)
        finalCalculation.pdv = finalCalculation.unitPrice - finalCalculation.baseAmount;
        return finalCalculation;
    }
    const discountData = passenger.discountPCT?.ticketTypeId;
    let basePrice = discountData ? price : regularPrice;

    if (passenger.discountPCT?.applyRoundPrice && !passenger.discountPCT?.explicit) {
        if (passenger.discountPCT?.applyDiscountOneWay && directionType === DIRECTION_NAME[0]) {
            basePrice = Math.ceil(basePrice / 10) * 10;
        }
        if (passenger.discountPCT?.applyDiscountReturnTicket && directionType === DIRECTION_NAME[1]) {
            basePrice = Math.ceil(basePrice / 10) * 10;
        }
    }

    finalCalculation.unitPrice = basePrice;
    finalCalculation.totalAmount = basePrice;
    finalCalculation.discount = discountData ? regularPrice - basePrice : 0;
    finalCalculation.baseAmount = calculateBase(finalCalculation.unitPrice, currentTaxRates);
    finalCalculation.pdv = finalCalculation.unitPrice - finalCalculation.baseAmount;
    return finalCalculation;
}

// ARTIKLI
const amountByService = (services, currentTaxRates, discountPCT, discountABS, passengerCount) => {
    const initialSummary = createSummarized(); // Initial empty summary
    return services.reduce((acc, service) => {
        const {
            price,
            includeDiscount
        } = service;

        let finalServiceCalculation = createSummarized();
        const totalPrice = toNumber(price) * passengerCount;
        finalServiceCalculation.unitPrice = toNumber(price);

        if (includeDiscount) {
            finalServiceCalculation.discount = calculateDiscount(totalPrice, discountPCT, discountABS);
        }

        finalServiceCalculation.baseAmount = calculateBase(finalServiceCalculation.unitPrice - finalServiceCalculation.discount, currentTaxRates);
        finalServiceCalculation.pdv = finalServiceCalculation.unitPrice - finalServiceCalculation.baseAmount;
        finalServiceCalculation.totalAmount = totalPrice;

        return aggregateSummaries(acc, finalServiceCalculation);
    }, initialSummary);
};

const amountBySalesAction = (totalSummary, salesAction, currentTaxRates, passengersCount, isInternational) => {
    if (!salesAction) {
        return totalSummary;
    }
    let finalSummaryWithAction = {...totalSummary};
    const {amount, amountInternational, salesActionType} = salesAction;
    const isAbsolute = salesActionType.isAbsolute;

    let discountValue = 0;
    let discountValueTotal = 0;

    if (!isAbsolute) {
        discountValue = (finalSummaryWithAction.unitPrice * (isInternational ? amountInternational : amount)) / 100;
        discountValueTotal = (finalSummaryWithAction.totalAmount * (isInternational ? amountInternational : amount)) / 100;
    } else {
        discountValue = toNumber(isInternational ? amountInternational : amount);
        discountValueTotal = toNumber(isInternational ? amountInternational : amount);
    }
    finalSummaryWithAction.unitPrice += discountValue;
    finalSummaryWithAction.totalAmount += discountValueTotal;

    finalSummaryWithAction.baseAmount = calculateBase(finalSummaryWithAction.unitPrice, currentTaxRates);
    finalSummaryWithAction.pdv = finalSummaryWithAction.unitPrice - finalSummaryWithAction.baseAmount;
    return finalSummaryWithAction;
};


const calculateBase = (unitPrice, currentTaxRates) => {
    const tax = toNumber(taxValueOfLabel(currentTaxRates));
    const baseAmount = toNumber(unitPrice) / (tax * 0.01 + 1);
    return toNumber(baseAmount.toFixed(2));
}

const taxValueOfLabel = (currentTaxRates) => {
    let tax = 0;
    const allRates = getAllCurrentTaxRates(currentTaxRates);
    for (let i = 0; i < allRates.length; i++) {
        if (allRates[i].label === TEST_VAT) {
            tax = allRates[i].rate;
            break;
        }
    }
    return tax;
};

export const calculateDiscountedPrice = (discountData, price) => {
    const {discountPCT = 0, discountABS = 0, applyRoundPrice = false} = discountData;
    let discount = 0;

    if (discountPCT > 0) {
        discount = toNumber(price) * (toNumber(discountPCT) / 100);
    } else if (discountABS > 0) {
        discount = toNumber(discountABS);
    }

    let discountedPrice = toNumber(price) - discount;

    if (applyRoundPrice) {
        discountedPrice = Math.ceil(discountedPrice / 10) * 10;
    }
    return discountedPrice;
};

const calculateDiscount = (unitPrice, discountPCT, discountABS, applyRoundPrice) => {
    let discount = 0;
    if (discountPCT > 0) {
        discount = ((unitPrice * (toNumber(discountPCT)) / 100));
    } else if (discountABS > 0) {
        discount = toNumber(discountABS);
    }
    if (applyRoundPrice) {
        discount = Math.ceil(discount / 10) * 10;
    }

    return discount.toFixed(2);
};

const aggregateSummaries = (summary1, summary2) => {
    return {
        baseAmount: toNumber(summary1.baseAmount) + toNumber(summary2.baseAmount),
        pdv: toNumber(summary1.pdv) + toNumber(summary2.pdv),
        unitPrice: toNumber(summary1.unitPrice) + toNumber(summary2.unitPrice),
        discount: toNumber(summary1.discount) + toNumber(summary2.discount),
        totalAmount: toNumber(summary1.totalAmount) + toNumber(summary2.totalAmount)
    };
}

// TODO za akcije dodati logiku i obratiti paznju da li je medjunarodna

function splitItemsByQuantity(items) {
    const result = [];
    items.forEach(item => {
        for (let i = 0; i < item.quantity; i++) {
            const newItem = {
                totalAmount: item.unitPrice,
                quantity: 1,
                unitPrice: item.unitPrice,
                discount: item.discount,
                name: item.name,
                isAfterBorder: item.isAfterBorder,
                isReturnTicket: item.isReturnTicket,
                labels: [...item.labels],
                passengerUid: [item.passengerUid[i]],
                isDiscountApplied: item.isDiscountApplied,
                ticketType: item.ticketType
            };
            result.push(newItem);
        }
    });

    return result;
}

export const processPassengers = (
    itemsData,
    passengers,
    invoiceLine,
    startStation,
    endStation,
    returnTrip,
    currentTaxRates,
    directionType,
    dateTo,
    isOppositeTicket = false
) => {
    const ticketObjects = [];
    let itemIndex = 0;
    const splitItems = splitItemsByQuantity(itemsData);

    const outboundSplitItems = splitItems.filter(it => !it.isReturnTicket);
    const returnSplitItems = splitItems.filter(it => it.isReturnTicket);

    const hasSecondSegmentForSamePassenger = (idx) => {
        const a = splitItems[idx];
        const b = splitItems[idx + 1];
        if (!a || !b) return false;

        const aUid = a.passengerUid?.[0] ?? null;
        const bUid = b.passengerUid?.[0] ?? null;

        const samePassenger = aUid && bUid && aUid === bUid;
        const bothNotReturn = a.isReturnTicket === false && b.isReturnTicket === false;
        return samePassenger && bothNotReturn;
    };

    passengers.forEach((passenger, passengerIdx) => {
        if (directionType === DIRECTION_NAME[1]) {
            // POVRATNA: svakom putniku pripada tačno jedna polazna i jedna povratna stavka, uparene
            // po POZICIJI putnika (ne po dve uzastopne stavke), da sedište uvek dođe od pravog putnika.
            const outItem = outboundSplitItems[passengerIdx];
            if (outItem) {
                const passUid = outItem.passengerUid ? outItem.passengerUid[0] : null;
                ticketObjects.push(createTicketObject(
                    outItem,
                    passenger,
                    invoiceLine,
                    startStation,
                    endStation,
                    returnTrip,
                    outItem.discount,
                    outItem.totalAmount,
                    passUid,
                    dateTo,
                    isOppositeTicket
                ));
            }

            const retItem = returnSplitItems[passengerIdx];
            if (retItem) {
                const passUid = retItem.passengerUid ? retItem.passengerUid[0] : null;
                ticketObjects.push(createTicketObject(
                    retItem,
                    passenger,
                    invoiceLine,
                    startStation,
                    endStation,
                    returnTrip,
                    retItem.discount,
                    retItem.totalAmount,
                    passUid,
                    dateTo,
                    isOppositeTicket
                ));
            }
        } else {
            // JEDAN SMER
            const item = splitItems[itemIndex];
            if (!item) return;

            const passUid = item.passengerUid ? item.passengerUid[0] : null;

            if (hasSecondSegmentForSamePassenger(itemIndex)) {
                const itemA = splitItems[itemIndex];
                const itemB = splitItems[itemIndex + 1];

                const ticketA = createTicketObject(
                    itemA,
                    passenger,
                    invoiceLine,
                    startStation,
                    endStation,
                    returnTrip,
                    itemA.discount,
                    itemA.totalAmount,
                    passUid,
                    null,
                    isOppositeTicket
                );
                ticketObjects.push(ticketA);

                const ticketB = createTicketObject(
                    itemB,
                    passenger,
                    invoiceLine,
                    startStation,
                    endStation,
                    returnTrip,
                    itemB.discount,
                    itemB.totalAmount,
                    passUid,
                    null,
                    isOppositeTicket
                );
                ticketObjects.push(ticketB);

                itemIndex += 2;
            } else {
                const ticket = createTicketObject(
                    item,
                    passenger,
                    invoiceLine,
                    startStation,
                    endStation,
                    returnTrip,
                    item.discount,
                    item.totalAmount,
                    passUid,
                    null,
                    isOppositeTicket
                );
                ticketObjects.push(ticket);
                itemIndex += 1;
            }
        }
    });

    // Redosled je već [polazna, povratna] po putniku pa nema potrebe za dodatnim preuređivanjem.
    // (Backend ionako uparuje povratnu sa polaznom po putniku — passenger.id — a ne po redosledu.)
    return ticketObjects;
};


const createTicketObject = (item, passenger, invoiceLine, startStation, endStation, returnTrip, discountValue, totalAmount, passUid, dateTo, isOppositeTicket) => {
    const returnDate = item.isReturnTicket
        ? (moment(dateTo).isValid()
            ? moment.utc(dateTo).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
            : returnTrip?.departureTripTime || null)
        : (moment(invoiceLine?.departureTripTime).isValid()
            ? moment.utc(invoiceLine.departureTripTime).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
            : null)

    return {
        trip: item.isReturnTicket
            ? (returnTrip?.tripId != null ? {id: returnTrip.tripId} : null)
            : {id: invoiceLine.tripId},
        ticketType: item.ticketType || {id: 1},
        isReturnTicket: item.isReturnTicket,
        departureStation: {id: item.isReturnTicket ? endStation.id : startStation.id},
        arrivalStation: {id: item.isReturnTicket ? startStation.id : endStation.id},
        journeyDate: returnDate,
        itemName: item.name,
        labels: JSON.stringify(item.labels),
        price: totalAmount,
        discountAmount: discountValue,
        seatReserved: item.isReturnTicket ? passenger?.returnSeat != null ? passenger?.returnSeat : null : passenger.seat || null,
        vehicleId: item.isReturnTicket ? passenger?.returnVehicleId != null ? passenger?.returnVehicleId : null : passenger.vehicleId || null,
        passenger: {
            passengerUid: passUid,
            passengerName: passenger?.name || null,
            passengerLastName: passenger?.lastName || passenger?.surname|| null,
            passengerTelephone: passenger?.phone || null,
            passengerEmail: passenger?.email || null,
            passengerDocumentNumber: passenger?.cardNumber || null,
            type: passenger?.type || null
        },
        isOppositeTicket: isOppositeTicket
    };
};


export const calculateTotalSum = (allInvoiceItems, saleAction, currentTaxRates, PAYMENT_TYPE, passengersCount, isInternational) => {
    let totalCalc = {
        baseAmount: 0,
        pdv: 0,
        unitPrice: 0,
        discount: 0,
        totalAmount: 0
    };
    allInvoiceItems.forEach(item => {

        const baseAmount = calculateBase(item.totalAmount, currentTaxRates);
        const pdv = item.totalAmount - baseAmount;
        totalCalc.baseAmount += baseAmount;
        totalCalc.pdv += pdv;
        totalCalc.unitPrice += item.unitPrice;
        totalCalc.totalAmount += item.totalAmount || 0;

        if (item.discount) {
            totalCalc.discount += item.discount;
        }
    });
    if (saleAction) {
        totalCalc = amountBySalesAction(totalCalc, saleAction, currentTaxRates, passengersCount, isInternational, 2);
    }
    return {
        amount: roundToTwoDecimals(totalCalc.totalAmount),
        paymentType: PAYMENT_TYPE,
        baseAmount: roundToTwoDecimals(totalCalc.baseAmount),
        pdv: roundToTwoDecimals(totalCalc.pdv),
        discount: roundToTwoDecimals(totalCalc.discount)
    };
};


const roundToTwoDecimals = (num) => Math.round(num * 100) / 100;

const getDirectionPrice = (directionType, {price, returnPrice, priceMonthly}, externalSale) => {
    switch (directionType) {
        case DIRECTION_NAME[0]:
            return price;
        case DIRECTION_NAME[1]:
            if (externalSale) {
                return price;
            }
            return returnPrice;
        case DIRECTION_NAME[2]:
            return priceMonthly;
        default:
            return 0;
    }
};
